import { h } from 'preact'

interface Props {
    message: string
}

const WarningBox = ({ message }: Props) => <div className='warning-box'> { message } </div>

export default WarningBox
